import { Store, legacy_createStore as createStore, applyMiddleware, UnknownAction } from "redux"
import createSagaMiddleware from "redux-saga"
import { cableMiddleware } from "../../shared/components/cable/cableMiddleware"
import { composeWithDevTools } from "@redux-devtools/extension"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import appReducer from "./appReducer"
import appSaga from "./appSaga"
import { IAppState } from "../appTypes"
import { loadSession } from "./appSessionStorage"
import { AccountActionTypes } from "../../features/account/state/accountTypes"

const persistedState = loadSession()
const initialState = { ...persistedState } as unknown as (IAppState & { _persist: { version: number; rehydrated: boolean } })

export const sagaMiddleware = createSagaMiddleware()

const rootReducer = (state: IAppState | undefined, action: UnknownAction) => {
  if (action?.type == AccountActionTypes.SIGN_OUT_USER_ASYNC_SUCCESS) {
    state = undefined
  }
  return appReducer(state, action)
}

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "ui",
    "liveMeetingConfig"
  ]
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store: Store<IAppState> = createStore(
  persistedReducer,
  initialState,
  composeWithDevTools(
    applyMiddleware(
      sagaMiddleware,
      cableMiddleware
    )
  ),
)

export const persistor = persistStore(store)

sagaMiddleware.run(appSaga)
